// extracted by mini-css-extract-plugin
module.exports = {"view":"blog-page_view__3o7Ev","title":"blog-page_title__2w_IG","content":"blog-page_content__2CQGT","section":"blog-page_section__1lCHD","other":"blog-page_other__j8WiV"};